import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import * as citationStyles from '../../../styles/widgets/citation.module.scss';
import PolyLink from '../PolyLink';

const Citation = ({elem, column, row}) => {
  const {
    url_alt,
    block_bottom,
    open_in_new_window,
    text,
    url
  } = elem;

  const content = (
    <>
      <div className={citationStyles.item}>
        <blockquote>
          <p
            className={clsx(citationStyles.h3Text, citationStyles.citation)}
          >
            {text}
          </p>
        </blockquote>
      </div>
      <div className={citationStyles.item}>
        <p
          className={clsx(citationStyles.bottomLines, styleLink.withoutIcon)}
          style={{fontSize: 18, fontWeight: 500}}
        >
          {block_bottom}
        </p>
      </div>
    </>
  );

  return (
    <div className={citationStyles.bloc}>
      <div
        className={citationStyles.minimumHeight}
        style={{
          paddingBottom: `calc((100% / ${column}) * (${row}))`,
        }}
      />
      <div
        className={citationStyles.mainBloc}
      >
        {url ? (
          <PolyLink
            ariaLabel={url_alt}
            className={citationStyles.link}
            dataCy="citation-link"
            target={open_in_new_window ? '_blank' : ''}
            url={url}
          >
            {content}
          </PolyLink>
        ) : (content)}
      </div>
    </div>
  );
};

Citation.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    url_alt: PropTypes.string,
    block_bottom: PropTypes.string,
    open_in_new_window: PropTypes.bool,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  row: PropTypes.number
};

export default Citation;
